{
    AOS.init();
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".testi-vid-bx");
    const allVideos = document.querySelectorAll(".testi-vid-bx video");
    function pauseAllVideos() {
      allVideos.forEach((video) => {
        video.pause();
        const playIcon = video
          .closest(".testi-vid-bx")
          .querySelector(".vid-play-pause-par");
        playIcon.style.display = "grid";
      });
    }
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playIcon = box.querySelector(".vid-play-pause-par");
      box.addEventListener("click", function () {
        if (video.paused) {
          pauseAllVideos();
          video.play();
          playIcon.style.display = "none";
        } else {
          video.pause();
          playIcon.style.display = "grid";
        }
      });
      video.addEventListener("play", function () {
        playIcon.style.display = "none";
      });
      video.addEventListener("pause", function () {
        playIcon.style.display = "grid";
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
        const accordionItems = document.querySelectorAll(".accordion-item");
        if (accordionItems.length > 0) {
          accordionItems[0].classList.add("open");
        }
        accordionItems.forEach((item) => {
          const header = item.querySelector(".accordion-item-header");
          header.addEventListener("click", () => {
            document
              .querySelectorAll(".accordion-item")
              .forEach((otherItem) => {
                if (
                  otherItem !== item &&
                  otherItem.classList.contains("open")
                ) {
                  otherItem.classList.remove("open");
                }
              });
            item.classList.toggle("open");
          });
        });
      });
}